import { createSlice } from "@reduxjs/toolkit";
import {
  getUserDashboardTemplate,
  updateUserDashboardTemplateOrder,
  updateUserDashboardTemplateVisibility,
  fetchTotalProfitBeforeTaxes,
  fetchTotalPaidAndSentInvoices,
  fetchTotalDoneAndTodoTasks,
  fetchCompletedAndActiveProjects,
  fetchTotalAgreements,
  fetchRecentTransactions,
  fetchTimerActivities,
  fetchNotes,
  updateNotes,
} from "../service/dashboardService";

const dashboardInitialState = {
  template: null,
  totalProfitData: null,
  invoiceData: null,
  taskData: null,
  projectData: null,
  agreementData: null,
  recentTrData: null,
  timeTrackingData: null,
  notesData: null,
  isLoading: false,
  error: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: dashboardInitialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      // get and create user template
      .addCase(getUserDashboardTemplate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUserDashboardTemplate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.template = action.payload.data;
      })
      .addCase(getUserDashboardTemplate.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      //update user template orders
      .addCase(updateUserDashboardTemplateOrder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateUserDashboardTemplateOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.template = action.payload.data;
      })
      .addCase(updateUserDashboardTemplateOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      //update user template visibility
      .addCase(updateUserDashboardTemplateVisibility.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(
        updateUserDashboardTemplateVisibility.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.template = action.payload.data;
        }
      )
      .addCase(
        updateUserDashboardTemplateVisibility.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.error.message;
        }
      )

      // fetch profit before tax
      .addCase(fetchTotalProfitBeforeTaxes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTotalProfitBeforeTaxes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.totalProfitData = action.payload.data;
      })
      .addCase(fetchTotalProfitBeforeTaxes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // fetch invoices details
      .addCase(fetchTotalPaidAndSentInvoices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTotalPaidAndSentInvoices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.invoiceData = action.payload.data;
      })
      .addCase(fetchTotalPaidAndSentInvoices.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // fetch task details
      .addCase(fetchTotalDoneAndTodoTasks.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTotalDoneAndTodoTasks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.taskData = action.payload.data;
      })
      .addCase(fetchTotalDoneAndTodoTasks.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // fetch project details
      .addCase(fetchCompletedAndActiveProjects.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCompletedAndActiveProjects.fulfilled, (state, action) => {
        state.isLoading = false;
        state.projectData = action.payload.data;
      })
      .addCase(fetchCompletedAndActiveProjects.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // fetch agreement data
      .addCase(fetchTotalAgreements.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTotalAgreements.fulfilled, (state, action) => {
        state.isLoading = false;
        state.agreementData = action.payload.data;
      })
      .addCase(fetchTotalAgreements.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // fetch recent transcation data
      .addCase(fetchRecentTransactions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchRecentTransactions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.recentTrData = action.payload.data;
      })
      .addCase(fetchRecentTransactions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // fetch timer activities
      .addCase(fetchTimerActivities.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTimerActivities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.timeTrackingData = action.payload.data;
      })
      .addCase(fetchTimerActivities.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // fetch sData
      .addCase(fetchNotes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchNotes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notesData = action.payload.data;
      })
      .addCase(fetchNotes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // update notes
      .addCase(updateNotes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateNotes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notesData = action.payload.data;
      })
      .addCase(updateNotes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const dashboardActions = dashboardSlice.actions;

export default dashboardSlice.reducer;
